import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { App } from "./App";
import { AuthProvider } from "./AuthContext";
import { ReplayProvider } from "./ReplayContext";
import { ThemeProvider } from "./ThemeProvider";
import { VoiceControlProvider } from "./VoiceControlContext";
import { VoiceSessionProvider } from "./VoiceSessionContext";
import "./styles/index.css";
import { initTheme } from "./theme";

const initialTheme = initTheme();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1 },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider initialTheme={initialTheme}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <VoiceSessionProvider>
              <VoiceControlProvider>
                <Routes>
                  <Route path="/" element={<Navigate to="/live" replace />} />
                  <Route path="/live/*" element={<App env="live" />} />
                  <Route
                    path="/sim/*"
                    element={
                      <ReplayProvider>
                        <App env="sim" />
                      </ReplayProvider>
                    }
                  />
                </Routes>
              </VoiceControlProvider>
            </VoiceSessionProvider>
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
);
